import React, { useState, useEffect } from "react";

import { styled, alpha } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { CardActionArea } from "@mui/material";

import liff from "@line/liff";
import { PostData } from "../../services/Request";
import * as Defi from "../../services/Define";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

export default function BookingPage() {
  const [member, setMember] = useState({});
  const [attr, setAttr] = useState({});
  const [list, setList] = useState([]);

  const init = (item) => {
    setMember({
      ...member,
      userId: item.userId,
      displayName: item.displayName,
      pictureUrl: item.pictureUrl,
      statusMessage: item.statusMessage,
      idToken: item.idToken,
      email: item.email,
    });

    PostData("course", "init", {
      course: 4,
      userid: item.userId,
    }).then((result) => {
      if (result.status === "OK") {
        setAttr(result.product);
        setList(result.course);
      }
    });
  };

  const lineLogin = () => {
    liff.init(
      { liffId: Defi.LIFF_ID },
      () => {
        if (liff.isLoggedIn()) {
          const idToken = liff.getIDToken();

          liff
            .getProfile()
            .then((profile) => {
              init({
                userId: profile.userId,
                displayName: profile.displayName,
                pictureUrl: profile.pictureUrl,
                statusMessage: profile.statusMessage,
                idToken: idToken,
                email: liff.getDecodedIDToken().email,
              });
            })
            .catch((err) => console.error(err));
        } else {
          liff.login();
        }
      },
      (err) => console.error(err)
    );
  };

  useEffect(() => {
    if (window.location.hostname === "localhost") {
      init({
        userId: Defi.DEBUG_ID,
        displayName: Defi.DEBUG_NAME,
        pictureUrl: Defi.DEBUG_PIC,
        statusMessage: Defi.DEBUG_STATUS,
        idToken: Defi.DEBUG_TOKEN,
        email: Defi.DEBUG_EMAIL,
      });
      return;
    }

    lineLogin();
  }, []);
  return (
    <Container component="main" maxWidth="xs">
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static">
          <Toolbar>
            <Search>
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Search…"
                inputProps={{ "aria-label": "search" }}
              />
            </Search>
          </Toolbar>
        </AppBar>
      </Box>
      <Box component="main" sx={{ pt: 2 }}>
        <Typography variant="h5" gutterBottom>
          {attr.name}
        </Typography>
        <Grid container spacing={2}>
          {list.map((item) => (
            <Grid item xs={12} key={item.code}>
              <Card>
                <CardActionArea>
                  <a
                    href={`https://www.youtube.com/watch?v=${item.youtube_id}&openExternalBrowser=1`}
                  >
                    <CardMedia
                      component="img"
                      height="180"
                      image={item.filepic}
                      alt="green iguana"
                    />
                  </a>
                  <CardContent>
                    <Typography gutterBottom variant="h6" component="div">
                      {item.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {item.date_create}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
}
